import { Box, SectionHelper, Text } from '@wix/design-system';
import t__default, { useContext, useState } from 'react';
import { o } from '../../RevertSmall-778c3822.js';
import { RicosContext } from 'ricos-context';

const LS_KEY = "ricos/color-picker/live-site-color-hint/closed";
const ColorPickerLiveSiteColorHint = () => {
  const { t } = useContext(RicosContext);
  const [isClosed, setIsClosed] = useState(() => !!(localStorage == null ? void 0 : localStorage.getItem(LS_KEY)));
  const onClose = () => {
    localStorage == null ? void 0 : localStorage.setItem(LS_KEY, "true");
    setIsClosed(true);
  };
  if (isClosed) {
    return null;
  }
  return /* @__PURE__ */ t__default.createElement(Box, { marginTop: "SP2" }, /* @__PURE__ */ t__default.createElement(SectionHelper, { appearance: "standard", onClose, size: "small" }, /* @__PURE__ */ t__default.createElement(Box, { direction: "horizontal", gap: "SP2" }, /* @__PURE__ */ t__default.createElement(Text, null, /* @__PURE__ */ t__default.createElement(o, null)), /* @__PURE__ */ t__default.createElement(Text, { size: "small" }, t("ColorPickerLiveSiteColorHint")))));
};

export { ColorPickerLiveSiteColorHint };
//# sourceMappingURL=live-site-color-hint.js.map
